// Normalize a city string for display: strip "ישראל", take the first segment,
// and collapse "תל אביב-יפו" / "תל אביב יפו" → "תל אביב".
export function cleanCity(city?: string | null): string {
  if (!city) return '';
  let c = city.replace(/,?\s*ישראל\s*$/i, '').split(',')[0].trim();
  c = c.replace(/תל[\s\-־]+אביב[\s\-־]+יפו/g, 'תל אביב');
  return c.trim();
}
